import styled from 'styled-components'

export const StyledChartsContainer = styled.div`
  background: #ffffff;
  border: 0.5px solid ${({ theme }) => theme.colors.borderDefault};
  box-sizing: border-box;
  border-radius: 12px;
  width: 585px;
  height: 390px;
  position: relative;
  padding: 10px 33px;

  .header {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
    border-bottom: 0.5px solid ${({ theme }) => theme.colors.borderDefault};
    padding: 15px 0px 15px;
  }

  .title {
    font-size: 17px;
    line-height: 27px;
    color: ${({ theme }) => theme.colors.textContent};
    font-weight: bold;
    margin-bottom: 0;
  }

  #lon-price-chart {
    margin-top: 20px;
  }
  @media screen and (max-width: 640px) {
    width: 100% !important;
    height: 100%;
    padding: 10px 10px;

    .header {
      padding: 0;
      padding-bottom: 10px;
      .title {
        font-size: 19px;
      }
    }
  }
`
